import { useWindowWidth } from '@react-hook/window-size'
import { Flex } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { ContentBlock } from 'src/home_page/components/ContentBlock/ContentBlock'
import { VideoPlayer } from 'src/home_page/components/VideoPlayer/VideoPlayer'

type PrimaryActionType = {
  title: string
  bgColor?: string
  textColor?: string
  onClick: () => void
}

type VideoPlayerSectionProps = {
  title: string
  description: string
  isSmallMobile: boolean
  iFrameSrc: string
  thumbnailUrl: string
  primaryAction: PrimaryActionType
  isComponentRight?: boolean
}

export const VideoPlayerSection: React.FC<VideoPlayerSectionProps> = ({
  title,
  description,
  isSmallMobile,
  iFrameSrc,
  thumbnailUrl,
  primaryAction,
  isComponentRight,
}) => {
  const windowWidth = useWindowWidth()
  return (
    <Flex
      width="100%"
      inset={
        isSmallMobile
          ? {
              horizontal: '1.5rem',
              vertical: '4rem',
            }
          : '4rem'
      }
      alignItems="center"
      justifyContent="center"
      flexDirection={
        isComponentRight && windowWidth <= 1024
          ? 'column-reverse'
          : isComponentRight
          ? 'row-reverse'
          : windowWidth <= 1024
          ? 'column'
          : 'row'
      }
      columnGap="x5"
      rowGap="4rem"
    >
      <VideoPlayer
        thumbnailUrl={thumbnailUrl}
        playbackOption={{
          iframeSrc: iFrameSrc,
          iframeTitle: 'tilted',
        }}
        width={windowWidth <= 700 ? '100%' : '650px'}
        btnColor="#fff"
        height="400px"
      />
      <ContentBlock
        title={title}
        description={description}
        primaryAction={primaryAction}
        width={windowWidth <= 1024 ? '100%' : '406px'}
      />
    </Flex>
  )
}
